import { useEffect, useRef } from "react";

/**
 * Renders Cloudflare Turnstile when NEXT_PUBLIC_TURNSTILE_SITE_KEY is set.
 * When unset, auth works without bot protection (local/dev).
 */
export function TurnstileField({ onToken }) {
  const ref = useRef(null);
  const siteKey = (
    process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY ||
    (typeof window !== "undefined" && window.__VEDAPATH_ENV__?.turnstileSiteKey) ||
    ""
  ).trim();

  useEffect(() => {
    if (!siteKey || !ref.current) {
      onToken?.("");
      return undefined;
    }

    let widgetId;
    let cancelled = false;

    function render() {
      if (cancelled || !window.turnstile || !ref.current) return;
      widgetId = window.turnstile.render(ref.current, {
        sitekey: siteKey,
        callback: (token) => onToken?.(token),
        "expired-callback": () => onToken?.(""),
        "error-callback": () => onToken?.(""),
      });
    }

    if (window.turnstile) {
      render();
    } else {
      const existing = document.querySelector("script[data-vedapath-turnstile]");
      if (!existing) {
        const script = document.createElement("script");
        script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
        script.async = true;
        script.dataset.vedapathTurnstile = "1";
        script.onload = render;
        document.head.appendChild(script);
      } else {
        existing.addEventListener("load", render);
      }
    }

    return () => {
      cancelled = true;
      if (widgetId != null && window.turnstile?.remove) {
        window.turnstile.remove(widgetId);
      }
    };
  }, [siteKey, onToken]);

  if (!siteKey) return null;
  return <div ref={ref} className="flex justify-center" data-testid="turnstile" />;
}
